import { Navigate, Route, Routes } from "react-router-dom";

const Redirect = () => {
    return (
        <Routes>
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
    );
};

export default Redirect;